// Public store listings for the native app. These are the REAL, permanent
// URLs (Apple ID from App Store Connect, Play package name) — they are final
// even though the listings 404 until each store release is published.
// The SmartAppBanner goes live for mobile-web users as soon as these are
// non-empty; index.html also carries the matching apple-itunes-app meta tag
// so Safari shows its native smart banner once the iOS listing is public.
// Single source for the raw identifiers, reused by both the listing URLs below
// and @capawesome/capacitor-app-update's openAppStore({ appId }) in the
// force-update gate (src/hooks/useVersionCheck.ts).
export const APPLE_APP_STORE_ID = '6775908514'
export const ANDROID_PACKAGE_NAME = 'ai.zerosnag.app'

export const STORE_URLS = {
  ios: `https://apps.apple.com/de/app/id${APPLE_APP_STORE_ID}`,
  android: `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`,
} as const
